import React from 'react';
import { AdminMediaDashboard } from '../components/AdminMediaDashboard';

export function AdminMediaManagement() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <AdminMediaDashboard className="px-4 sm:px-6 lg:px-8" />
    </div>
  );
}